var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_2636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2163 2.78135C12.5057 -0.928065 6.49065 -0.927174 2.78123 2.78339C-0.928187 6.49396 -0.927297 12.509 2.78327 16.2184C6.49384 19.9278 12.5089 19.927 16.2183 16.2164C17.9998 14.4344 19.0003 12.0176 18.9998 9.49785C18.9993 6.9785 17.998 4.56253 16.2163 2.78135ZM14.3872 13.2333C14.3868 13.2337 14.3864 13.2341 14.3859 13.2345V13.2314L13.9046 13.7095C13.2821 14.3399 12.3755 14.5993 11.5137 14.3935C10.6456 14.1612 9.82025 13.7913 9.06908 13.2979C8.3712 12.8519 7.72446 12.3305 7.14058 11.743C6.60335 11.2097 6.1207 10.6242 5.69973 9.99504C5.23928 9.31809 4.87483 8.58066 4.61673 7.8037C4.32086 6.89095 4.56604 5.88941 5.25008 5.21654L5.81373 4.65289C5.97045 4.49547 6.22509 4.49491 6.38247 4.65163C6.38288 4.65203 6.38333 4.65244 6.38373 4.65289L8.16339 6.43254C8.32081 6.58926 8.32136 6.8439 8.16465 7.00128C8.16424 7.00169 8.16383 7.0021 8.16339 7.00254L7.11839 8.04754C6.81854 8.34412 6.78084 8.81541 7.02973 9.15589C7.40769 9.6746 7.82595 10.1627 8.28058 10.6157C8.78746 11.1248 9.33849 11.5879 9.92723 11.9996C10.2674 12.2369 10.7286 12.1969 11.0229 11.9046L12.033 10.8786C12.1898 10.7212 12.4444 10.7206 12.6018 10.8773C12.6022 10.8777 12.6026 10.8781 12.603 10.8786L14.3859 12.6646C14.5433 12.8213 14.5439 13.0759 14.3872 13.2333Z",
    fill: "#546EDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_2636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot2);
export default __webpack_public_path__ + "static/media/bot2.cfd7b42ec7dc3b2c61601580c157e825.svg";
export { ForwardRef as ReactComponent };